<template>
  <div v-if="statement">
    <template v-if="isMrpaEnable && isMrpa">
      <div class="break section-block row-box">
        <WrapperField
          :data="
            createDataField({
              fieldName: FieldName.IS_MRPA,
              fieldValue: isMrpaValue,
            })
          "
        ></WrapperField>
      </div>
      <div v-if="!isManual" class="break section-block row-box">
        <WrapperField
          :data="
            createDataField({
              fieldName: FieldName.MRPA_AUTHORITY_DOCUMENT,
              fieldValue: authorityDocument,
            })
          "
        ></WrapperField>
      </div>
    </template>

    <!-- физическое лицо: start -->
    <Person
      v-if="person"
      :data="subject"
      :statement-type="statement.statementType"
    />
    <!-- физическое лицо: end -->

    <!-- организация: start -->
    <Organization
      v-if="organization"
      :data="subject"
      :statement-type="statement.statementType"
    />
    <!-- организация: end -->

    <!-- иностранное юридическое лицо: start -->
    <ForeignOrganization
      v-if="foreignOrganization"
      :data="subject"
      :statement-type="statement.statementType"
    />
    <!-- иностранное юридическое лицо: end -->

    <template v-if="mrpaEnable">
      <MrpaBaseAuthority
        v-if="baseAuthority"
        :data="baseAuthority"
        :statement-type="statement.statementType"
      />
      <MrpaNotaryDocument v-if="notaryInfo" :data="notaryInfo" />
      <MrpaAssistant v-if="assistantInfo" :data="assistantInfo" />
    </template>

    <JobPlace :data="subject" v-if="subject.jobPlace" />

    <template v-if="subject.account">
      <TitleField :fieldName="FieldName.CREDITOR_ACCOUNT_TITLE" />
      <BankDetails :data="subject.account" />
    </template>

    <template v-if="subject.details">
      <TitleField :fieldName="FieldName.CREDITOR_DETAILS_TITLE" />
      <SubjectDetails :data="subject.details" />
    </template>
  </div>
</template>

<script>
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import MrpaBaseAuthority from '@/components/elements/statement/FullStatementView/elements/MrpaBaseAuthority';
import MrpaNotaryDocument from '@/components/elements/statement/FullStatementView/elements/MrpaNotaryDocument';
import MrpaAssistant from '@/components/elements/statement/FullStatementView/elements/MrpaAssistant';
import { isMrpaEnable } from '@/app.config';
import { ApplicantRoleConst, SubjectFillType } from '@/constants';
import { FieldName } from '@/constants';
import JobPlace from '@/components/elements/statement/FullStatementView/elements/JobPlace';
import SubjectDetails from '@/components/elements/statement/FullStatementView/elements/SubjectDetails';
import BankDetails from '@/components/elements/statement/FullStatementView/elements/BankDetails';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';

export default {
  name: 'StepSubject',
  components: {
    Person,
    Organization,
    ForeignOrganization,
    WrapperField,
    MrpaBaseAuthority,
    MrpaNotaryDocument,
    JobPlace,
    SubjectDetails,
    BankDetails,
    TitleField,
    MrpaAssistant,
  },
  props: ['statement', 'subject'],
  methods: {},
  data: () => ({
    FieldName,
    createDataField,
  }),
  computed: {
    isMrpaEnable() {
      return isMrpaEnable(this.statement.statementType);
    },

    person() {
      return this.subject.person;
    },

    organization() {
      return this.subject.organization;
    },

    foreignOrganization() {
      return this.subject.foreignOrganization;
    },

    fillType() {
      return this.subject.uiContext?.fillType;
    },

    trusteeInfo() {
      return (
        this.person?.trusteeInfo ||
        this.organization?.trusteeInfo ||
        this.foreignOrganization?.trusteeInfo
      );
    },

    trusteeOrganizationInfo() {
      return (
        this.person?.trusteeOrganizationInfo ||
        this.organization?.trusteeOrganizationInfo ||
        this.foreignOrganization?.trusteeOrganizationInfo
      );
    },

    baseAuthority() {
      return (
        this.trusteeInfo?.baseAuthority ||
        this.trusteeOrganizationInfo?.baseAuthority
      );
    },

    authorityDocument() {
      return (
        this.trusteeInfo?.documents?.authorityDocument ||
        this.trusteeOrganizationInfo?.documents?.authorityDocument
      );
    },

    isManual() {
      if (this.statement.applicantRole === ApplicantRoleConst.APPLICANT) {
        return this.statement.applicantRole === ApplicantRoleConst.APPLICANT;
      }

      return [SubjectFillType.MANUAL, SubjectFillType.ASSIGNEE].includes(
        this.fillType
      );
    },

    notaryInfo() {
      return this.trusteeInfo?.notaryInfo;
    },

    assistantInfo() {
      return this.trusteeInfo?.assistantInfo;
    },

    isMrpa() {
      return this.statement.applicantRole || this.fillType;
    },

    isMrpaValue() {
      if (this.statement.applicantRole) {
        return this.statement.applicantRole === ApplicantRoleConst.TRUSTEE;
      }

      return this.fillType === SubjectFillType.MACHINE;
    },
  },
};
</script>
